<div class="teledeteccion-datepicker-container">
  <mat-chip
    class="datepicker-chip"
    (click)="prevDay()"
    [disabled]="isPrevDisabled">
    <span class="material-symbols-rounded">chevron_left</span>
  </mat-chip>
  <mat-chip-option
    selectable="false"
    class="custom-datepicker-btn"
    [disabled]="isDisabled()"
    [ngClass]="{
      'selected-indice': selectedDate(),
    }"
    (click)="openDatepicker()">
    <div style="display: flex; align-items: center">
      <span>
        @if (selectedDate()) {
          Fecha: {{ selectedDate() | date: 'dd/MM' }}
        } @else {
          Selecciona una fecha
        }
      </span>
      <mat-icon>arrow_drop_down</mat-icon>
    </div>
  </mat-chip-option>
  <mat-chip
    class="datepicker-chip"
    (click)="nextDay()"
    [disabled]="isNextDisabled">
    <span class="material-symbols-rounded">chevron_right</span>
  </mat-chip>
</div>

<!-- Input oculto para el datepicker -->
<mat-form-field
  class="hidden-datepicker"
  [style]="{
    display: isCalendarOpen() ? 'flex !important' : 'none !important',
  }">
  <mat-datepicker
    class="calendar-container"
    #picker
    (closed)="onDatepickerClosed()"></mat-datepicker>
  <input
    matInput
    [matDatepicker]="picker"
    [value]="selectedDate()"
    [max]="maxDate"
    [min]="minDate"
    (dateChange)="onDateChange($event.value)"
    readonly />
</mat-form-field>

<!-- Datepicker filter
    [matDatepickerFilter]="myFilter" 
  -->
